import { TOKEN_KEY, STSTEM_STATE_KEY } from '@/config/index';

const TokenKey = TOKEN_KEY;

export function getToken() {
  return getStorageData(TokenKey);
}

export function setToken(token, expires) {
  return setStorageData(TokenKey, token);
}

export function removeToken() {
  removeStorageData(TOKEN_KEY);
  removeStorageData(STSTEM_STATE_KEY);
  return;
}

export function getStorageData(key) {
  return sessionStorage.getItem(key);
}
export function setStorageData(key, data) {
  return sessionStorage.setItem(key, data);
}
export function removeStorageData(key) {
  return sessionStorage.removeItem(key);
}
